export default "# Quellcode Referenzen\n\n[Hier können Sie die Quellcode Referenzen für die Software einfügen...]"